const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayEdLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CMYK",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 841.89 311.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m160.47,177.51c0-17.29,11.2-32.34,33.09-32.34s33.09,15.05,33.09,32.34-11.2,32.34-33.09,32.34-33.09-15.05-33.09-32.34Zm45.78,0c0-8.96-3.98-14.93-12.69-14.93s-12.69,5.97-12.69,14.93,3.98,14.93,12.69,14.93,12.69-5.97,12.69-14.93Z",
    style: {
      fill: "#fed34c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.87,146.16h20.4v5.35c3.61-3.98,8.46-6.34,15.67-6.34,15.92,0,26.87,12.32,26.87,32.34s-12.19,32.34-28.86,32.34c-6.1,0-10.82-1.49-13.68-4.73v29.11h-9.18c-6.19,0-11.22-5.02-11.22-11.22v-76.86Zm43.04,31.35c0-10.33-5.1-14.93-11.82-14.93s-11.82,4.6-11.82,14.93,5.1,14.93,11.82,14.93,11.82-4.6,11.82-14.93Z",
    style: {
      fill: "#fed34c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.44,121.77v7.67c0,6.21,5.03,11.24,11.24,11.24h12.4v68.18h22.14v-68.18h12.4c6.21,0,11.24-5.03,11.24-11.24v-7.67h-69.42Z",
    style: {
      fill: "#fed34c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.1,177.57c0-14.8,8.96-32.34,31.6-32.34s30.73,17.91,30.73,31.1v7.46h-42.3c1.74,5.97,6.1,9.58,12.44,9.58,5.6,0,9.33-1.87,12.69-7.46l16.17,5.72c-5.23,11.44-14.55,18.29-29.73,18.29-22.64,0-31.6-17.54-31.6-32.34Zm43.04-7.96c-.62-5.35-4.48-9.58-11.44-9.58-5.1,0-9.45,2.99-11.32,9.58h22.76Z",
    style: {
      fill: "#fed34c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.92,190.88c0-12.44,8.96-20.53,26.37-20.53h9.95v-2.12c0-5.6-3.48-8.09-9.21-8.09-4.35,0-7.71,1.87-9.21,6.72l-15.67-3.73c2.36-10.08,11.32-17.91,24.88-17.91,17.17,0,27.62,7.59,27.62,26.25v37.44h-15.67l-1.37-6.72c-4.35,5.35-9.7,7.71-17.79,7.71-10.7,0-19.9-6.59-19.9-19.03Zm36.32-6.1v-.75h-9.83c-4.73,0-7.46,2.36-7.46,5.6s2.74,4.98,6.59,4.98c6.59,0,10.7-4.35,10.7-9.83Z",
    style: {
      fill: "#fed34c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m491.38,177.57c0-17.67,11.82-32.34,32.47-32.34,14.68,0,25.25,5.97,30.1,18.41l-18.04,7.46c-1.87-5.1-5.47-8.46-11.44-8.46-8.09,0-11.94,6.34-11.94,14.93s3.73,14.93,12.19,14.93c5.23,0,9.08-2.99,11.82-8.21l17.54,7.34c-5.6,12.56-15.42,18.29-30.23,18.29-20.65,0-32.47-14.68-32.47-32.34Z",
    style: {
      fill: "#fed34c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m571.97,120.85h6.74v32.59c3.36-4.85,10.45-8.21,18.16-8.21,14.06,0,21.52,7.59,21.52,21.77v41.92h-20.4v-36.32c0-6.1-3.61-9.21-8.09-9.21-7.34,0-11.2,6.22-11.2,18.04v27.49h-20.4v-74.41c0-7.54,6.12-13.66,13.66-13.66Z",
    style: {
      fill: "#fed34c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m623.13,177.57c0-14.8,8.96-32.34,31.6-32.34s30.73,17.91,30.73,31.1v7.46h-42.3c1.74,5.97,6.1,9.58,12.44,9.58,5.6,0,9.33-1.87,12.69-7.46l16.17,5.72c-5.23,11.44-14.55,18.29-29.73,18.29-22.64,0-31.6-17.54-31.6-32.34Zm43.04-7.96c-.62-5.35-4.48-9.58-11.44-9.58-5.1,0-9.45,2.99-11.32,9.58h22.76Z",
    style: {
      fill: "#fed34c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m702.71,146.22h8.12v6.84c3.23-4.73,10.08-7.84,17.42-7.84,3.23,0,6.09.75,8.21,1.74l-4.35,18.41c-1.87-1.12-3.86-1.74-6.47-1.74-7.22,0-14.8,6.1-14.8,23.01v22.27h-20.4v-50.41c0-6.78,5.5-12.28,12.28-12.28Z",
    style: {
      fill: "#fed34c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.88,121.84h-46.9c-6.22,0-11.26,5.04-11.26,11.26v7.65h23.64v68.18h22.14v-68.18h23.64v-7.65c0-6.22-5.04-11.26-11.26-11.26Z",
    style: {
      fill: "#fed34c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayEdLogo);
export default __webpack_public_path__ + "static/media/playEdLogo.7203f264514bc1fbee025b786e426e55.svg";
export { ForwardRef as ReactComponent };